import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Row, Select } from 'antd'
{ Option } = Select
import { BranchesOutlined, DatabaseOutlined } from '@ant-design/icons'
import GeneralTemplate from './general'
import './syncProject.scss'

ProjectPartial = ({
  title,
  project,
  projects,
  branch
}) ->

  [loading, setLoading] = useState(true)
  [branches, setBranches] = useState(undefined)

  useEffect( ->
    setBranches(undefined)
    setLoading(true)
    ( ->
      return unless project.get()
      b = await Weaver.Branch.list(project.get())
      setBranches(b)
      setLoading(false)
    )()
    undefined
  , [project])

  <div className="sync-project-partial">
    <h4>{ title }</h4>
    <div>
      <DatabaseOutlined />
      <Select
        disabled={!projects?}
        loading={!projects?}
        value={project.get()}
        placeholder="Choose a project"
        options={projects?.map((p) -> { value: p.id(), label: p.name() })}
        onSelect={(p) -> project.set(p)}
      />
    </div>
    <div>
      <BranchesOutlined />
      <Select
        disabled={!branches}
        loading={loading}
        value={branch.get()}
        placeholder="Choose a branch"
        options={branches?.map((b) -> { value: b.id(), label: b.name() })}
        onSelect={(b) -> branch.set(b)}
      />
    </div>
  </div>

SyncProject = GeneralTemplate({
  InputHandler: ({ startPlugin }) ->

    [projects, setProjects] = useState(undefined)
    [fromProj, setFromProj] = useState(undefined)
    [fromBranch, setFromBranch] = useState(undefined)
    [toProj, setToProj] = useState(undefined)
    [toBranch, setToBranch] = useState(undefined)

    useEffect( ->
      ( ->
        setProjects(
          await Weaver.Project.list()
        )
      )()
      undefined
    , [])

    <div>
      <Row style={{ margin: '30px 0 20px', minWidth: '600px'}}>
        <ProjectPartial
          title="From:"
          projects={projects}
          project={{ get: ( -> fromProj), set: setFromProj }}
          branch={{ get: ( -> fromBranch), set: setFromBranch }}
        />
      </Row>
      <Row style={{ margin: '30px 0 20px' }}>
        <ProjectPartial
          title="To:"
          projects={projects}
          project={{ get: ( -> toProj), set: setToProj }}
          branch={{ get: ( -> toBranch), set: setToBranch }}
        />
      </Row>
      <Button
        onClick={-> startPlugin({ fromProj, toProj, fromBranch, toBranch })}
        disabled={!fromBranch? or !fromProj? or !toBranch? or !toBranch?}
        type="primary"
        style={{ marginTop: 10 }}
      >
        Synchronize
      </Button>
    </div>
})

export default SyncProject
